import React, {FC, useMemo} from 'react';
import {PowerBIEmbed} from 'powerbi-client-react';
import {models} from 'powerbi-client';
import {Visual} from '../../reports/types';
import {useReports} from '../../../hooks/useReports';
import Spinner from '../../common/Spinner';
import {useHistory} from 'react-router-dom';

const DEFAULT_CONFIG = {
  type: 'visual',
  tokenType: models.TokenType.Embed,
  settings: {
    filterPaneEnabled: false,
    bookmarksPaneEnabled: false,
    persistentFiltersEnabled: false,
    navContentPaneEnabled: false,
    personalBookmarksEnabled: false,
    panes: {
      bookmarks: {
        visible: false
      },
      visualizations: {
        visible: false
      },
      syncSlicers: {
        visible: false
      },
      selection: {
        visible: false
      },
      pageNavigation: {
        visible: false
      },
      filters: {
        visible: false
      },
      fields: {
        visible: false
      }
    },
    bars: {
      actionBar: {
        visible: false
      }
    },
    visualSettings: {
      visualHeaders: [
        {
          settings: {
            visible: false
          }
        }
      ]
    }
  }
};

const getInitialConfig = (visual: Visual) => {
  const {visualName, pageName, report} = visual || {};

  return {
    ...DEFAULT_CONFIG,
    visualName,
    pageName,
    id: report?.powerbiReportId,
    embedUrl: undefined,
    accessToken: undefined
  };
};

type CartProps = {
  visual: Visual
}

const Card: FC<CartProps> = ({visual}) => {
  const initialConfig = useMemo(() => getInitialConfig(visual), [visual]);
  const history = useHistory();

  const {
    eventHandlers, embedConfig, isLoading, handleSetReport
  } = useReports({initialConfig, report: visual?.report});

  eventHandlers.set('visualClicked',
      function() {
        history.push('/reports/' + visual.report.id);
      });

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className="card">
      <PowerBIEmbed
        embedConfig={embedConfig}
        eventHandlers={eventHandlers}
        cssClassName="visual"
        getEmbeddedComponent={handleSetReport}
      />
    </div>
  );
};

export default Card;
